<template>
  <div>
    <el-dialog class="detailsDialog" width="1080px" title="还款" :visible.sync="form.dialog" :append-to-body="true">
      <div class="commonInfo">
        <div class="content" style="margin-top: 0;">
          <h3>姓名：{{ nickName }}</h3>
          <h3>会员卡号：{{ cardNo }}</h3>
          <h3>联系电话：{{ userPhone ? Lib.starPhone(userPhone) : '--' }}</h3>
          <h3>总赊账：{{ form.totalMoney ? form.totalMoney.toFixed(2) : '0.00' }}元</h3>
          <h3>已还款：{{ form.refundMoney ? form.refundMoney.toFixed(2) : '0.00' }}元</h3>
          <h3>未还款：{{ form.unRefundMoney ? form.unRefundMoney.toFixed(2) : '0.00' }}元</h3>
        </div>
      </div>
      <div style="margin-top: 15px;">
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="light" @selection-change="chooseOrder" @row-click="chooseOrderRow">
          <el-table-column type="selection" :selectable="checkTableSelection" width="55"></el-table-column>
          <el-table-column prop="createtime" label="赊账时间" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="ordercode" label="订单号" width="250" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="money" label="赊账金额（元）">
            <template slot-scope="scope">
              <span>{{ scope.row.money ? scope.row.money.toFixed(2) : '0.00' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="payMoney" label="已还金额（元）">
            <template slot-scope="scope">
              <span>{{ scope.row.payMoney ? scope.row.payMoney.toFixed(2) : '0.00' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="noPayMoney" label="未还金额（元）">
            <template slot-scope="scope">
              <span>{{ scope.row.noPayMoney ? scope.row.noPayMoney.toFixed(2) : '0.00' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <p class="repayTotal">
        <span>合计：</span>
        <samp class="themeFC">￥{{ inputVal }}</samp>
      </p>
      <div class="payStyleBox">
        <div class="pay-box-header">
          <strong>选择支付方式</strong>
        </div>
        <div class="pay-box-body clearFix" style="height:auto;overflow: hidden;">
          <div v-for="(v,n) in payTypeList" :key="n" class="pay-mode-box">
            <a :class="choosePayStatus == v.type ? 'checked' : ''" @click="choosePay(v.type)">
              <i class="iconfont" :class="choosePayStatus == v.type ? (''+v.icon) : ('themeFC '+v.icon)"></i>
              <span>{{ v.name }}</span>
            </a>
          </div>
        </div>
        <!-- <div class="pay-box-body clearFix">
          <div class="pay-mode-box">
            <a :class="choosePayStatus == 0 ? 'checked' : ''" @click="choosePay('1')">
              <i class="iconfont" :class="choosePayStatus == 1 ? '' : 'themeFC'">&#xe62b;</i>
              <span>现金支付</span>
            </a>
          </div>
          <div class="pay-mode-box">
            <a :class="choosePayStatus == 1 ? 'checked' : ''" @click="choosePay('2')">
              <i class="iconfont" :class="choosePayStatus == 2 ? '' : 'themeFC'">&#xe705;</i>
              <span>银行卡支付</span>
            </a>
          </div>
          <div v-if="ctName == '储值卡'" class="pay-mode-box">
            <a :class="choosePayStatus == 2 ? 'checked' : ''" @click="choosePay('3')">
              <i class="iconfont" :class="choosePayStatus == 3 ? '' : 'themeFC'">&#xe61a;</i>
              <span>会员卡支付</span>
            </a>
          </div>
          <div class="pay-mode-box">
            <a :class="choosePayStatus == 3 ? 'checked' : ''" @click="choosePay('4')">
              <i class="iconfont" :class="choosePayStatus == 4 ? '' : 'themeFC'">&#xe618;</i>
              <span>扫码支付</span>
            </a>
          </div>
          <div class="pay-mode-box">
            <a :class="choosePayStatus == 6 ? 'checked' : ''" @click="choosePay('7')">
              <i class="iconfont" :class="choosePayStatus == 7 ? '' : 'themeFC'">&#xe609;</i>
              <span>个人微信</span>
            </a>
          </div>
          <div class="pay-mode-box">
            <a :class="choosePayStatus == 7 ? 'checked' : ''" @click="choosePay('8')">
              <i class="iconfont" :class="choosePayStatus == 8 ? '' : 'themeFC'">&#xe6f9;</i>
              <span>个人支付宝</span>
            </a>
          </div>
        </div> -->
      </div>
      <div class="commonFooterBtn">
        <el-button class="ml_20" type="primary" :disabled="inputVal*1 > 0 ? disPayBtn : true" @click="confirmPay">确认支付</el-button>
        <el-button class="ml_20" @click="cancelPay">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="扫码支付" width="590px" :visible.sync="eqCodePayDialog" :append-to-body="true" :close-on-click-modal="false" :show-close="!scanQPayLoading" @close="clearBusinessLimit">
      <div class="commonNewPay" style="width: 500px;">
        <img style="margin: auto;display: block;margin-bottom: 20px;" src="static/images/default/scanCode.gif" />
        <p>
          需支付金额：
          <span v-text="'¥'+inputVal"></span>
        </p>
        <img class="hdScanIcon" src="static/images/icon/Scan.png" @click="getHdCamera" />
        <el-input ref="refsqp" v-model="paymentCode" v-focus :disabled="scanQPayLoading" placeholder="使用扫码枪扫码或输入付款码" class="input-with-select scanInput" style="width: 300px;    margin: 10px 90px 10px 92px;" @keyup.enter.native="scanQPaySubmit">
          <el-button slot="append" type="primary" style="color: #fff;height: 40px;" :loading="scanQPayLoading" @click="scanQPaySubmit">确定</el-button>
        </el-input>
        <p class="themeFC">支付过程中请勿关闭窗口，因网络问题引起的延迟，请耐心等候</p>
      </div>
    </el-dialog>

    <el-dialog title="会员消费密码" :visible.sync="payPasswordDia" width="520px" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <gt-consumptionCode :member-card="memberInfo" @successPassword="successPassword"></gt-consumptionCode>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMemberInfo,
  comfirmHk,
  getScanPayStatus,
  getOrderCode,
  newBarCodePay,
  getPaySet,
  getPayCodeList
} from './api/index';

export default {
  data() {
    return {
      cardNo: '', // 会员卡号
      ctName: '', // 会员卡名称
      nickName: '', // 会员昵称
      userPhone: '', // 联系电话
      money: '', // 会员卡余额
      inputVal: '0.00', // 搜索值
      orderId: '', // 订单ID
      orderCode: '', // 订单号
      eqCodeImage: '', // 二维码图片
      tableData: [], // 赊账列表
      comfirmList: [],
      choosePayStatus: 1, // 选择的支付状态
      eqCodePayDialog: false, // 二维码弹出框
      disPayBtn: false, // 支付按钮状态
      form: {
        // 赋值数据
        memberId: '',
        phone: '',
        totalMoney: '', // 总赊账
        refundMoney: '', // 已还款
        unRefundMoney: '', // 未还款
        dialog: false
      },

      setInterFlag: null,
      changePayImgStatus: true, // 扫码支付切换支付方式，true为微信支付，fasle为支付宝支付
      paymentCode: '', // 扫码支付付款码
      scanQPayLoading: false, // 扫码支付--确定loading
      sanQPayOrder: '', // 扫码支付订单号

      paySetStatus: '',

      // 5.7
      payPasswordDia: false,
      payPassword: '',
      memberInfo: {},

      // 5.9
      payTypeList: [],
      payCodeList: []
    };
  },
  // 监听弹出框的变化
  watch: {
    'form.dialog': function (val) {
      const vm = this;
      if (val == true) {
        vm.inputVal = '0.00';
        vm.getPayList();
        vm.getUserInfo();
      }
    },
    eqCodePayDialog(val) {
      if (val == false) {
        this.clearBusinessLimit;
      }
    }
  },
  created() {
    const vm = this;
    window.didGetQRCode = vm.returnHdCameraVal;
    vm.$emit('repayment', vm.form);
    getPaySet({}).then((res) => {
      if (res.code == 0) {
        vm.paySetStatus = res.data ? res.data : 0;
      }
    });
  },
  methods: {
    // 获取支付方式列表--5.9
    getPayList() {
      const data = {
        mainId: window.sessionStorage.mainId
      };
      this.payTypeList = [
        {
          name: '现金',
          type: 1,
          status: false,
          icon: 'icon-zhifu-01',
          price: null
        }, {
          name: '银行卡',
          type: 2,
          status: false,
          icon: 'icon-yinhangqia',
          price: null
        }, {
          name: '会员卡',
          type: 3,
          status: false,
          icon: 'icon-vip',
          price: null
        }, {
          name: '扫码支付',
          type: 4,
          status: false,
          icon: 'icon-saoma1',
          price: null
        }, {
          name: '个人微信',
          type: 7,
          status: false,
          icon: 'icon-weixin2',
          price: null
        }, {
          name: '个人支付宝',
          type: 8,
          status: false,
          icon: 'icon-zhifubao',
          price: null
        }
      ];
      this.choosePayStatus = 1;
      getPayCodeList(data).then((res) => {
        if (res.code == 0 && res.data) {
          this.payCodeList = res.data;
          res.data.forEach((a) => {
            if (a.payType * 1 > 99 && a.isOpen == 0) {
              const obj = {};
              obj.icon = 'icon-zhifufangshi';
              obj.isOpen = 0;
              obj.name = a.payTypeName;
              obj.price = null;
              obj.status = false;
              obj.type = a.payType;
              this.payTypeList.push(obj);
            }
          });
          this.totalPayCode();
        } else {
          this.payTypeList = [];
        }
      });
    },
    // 渲染支付方式列表数据
    totalPayCode() {
      this.payTypeList.forEach((a) => {
        this.payCodeList.forEach((b) => {
          if (a.type == b.payType) {
            a.isOpen = b.isOpen;
          }
        });
      });
    },
    // 输入消费密码--确定事件 5.7
    successPassword(val) {
      if (val) {
        this.payPasswordDia = false;
        this.payPassword = val;
        this.choosePayStatus = 3;
      } else {
        this.payPasswordDia = false;
      }
    },
    // 判断table  Selection是否可勾选
    checkTableSelection(row) {
      if (row.noPayMoney == 0) {
        return false; // 禁用
      }
      return true; // 不禁用
    },
    chooseOrderRow(row) {
      if (row.noPayMoney == 0) return;
      let index;
      let num = 0;
      this.comfirmList.forEach((a, n) => {
        if (a.id == row.id) {
          index = n;
        } else {
          num++;
        }
      });
      if (this.comfirmList.length == num) {
        this.comfirmList.push(row);
        this.chooseSelection(row);
      } else {
        this.comfirmList.splice(index, 1);
        this.delSelection(row);
      }
    },
    // 选择要还款的订单
    chooseOrder(selection) {
      let total = 0;
      selection.forEach((a) => {
        total += a.noPayMoney * 1;
      });
      this.inputVal = total.toFixed(2);
      this.comfirmList = selection;
      this.choosePay(this.choosePayStatus);
    },
    // 回选多选选择框--true
    chooseSelection(row) {
      const vm = this;
      setTimeout(() => {
        vm.$refs.multipleTable.toggleRowSelection(row, true);
      }, 100);
    },
    // 回选多选选择框--false
    delSelection(row) {
      const vm = this;
      setTimeout(() => {
        vm.$refs.multipleTable.toggleRowSelection(row, false);
      }, 100);
    },
    // 调用HD摄像头功能
    getHdCamera() {
      const status = this.Lib.pcOrMobile();
      if (status === 'mobile') {
        if (window.webkit) {
          window.webkit.messageHandlers.scanQRCode.postMessage(1);
        } else if (typeof dfAndroidAppHD != 'undefined') {
          // eslint-disable-next-line no-undef
          dfAndroidAppHD.openScanQRCode('1');
        } else {
          this.$message('此功能只能在HD上使用');
        }
      }
    },
    // 摄像头回调方法
    returnHdCameraVal(code) {
      this.paymentCode = code;
    },
    // 选择支付方式
    choosePay(val) {
      const vm = this;
      if (val == 3 && (vm.inputVal * 1) > (vm.money * 1)) {
        vm.$message({
          message: '会员余额不足，请换另一种支付方式！',
          type: 'error'
        });
        return;
      }
      if (vm.payPassword == '' && val == 3 && vm.memberInfo.inputPwd == 1) {
        vm.payPasswordDia = true;
        return;
      }
      if (val == 4) {
        if (vm.paySetStatus == 0) {
          vm.$message('您尚未开通扫码支付');
          return;
        }
        if (!vm.inputVal) {
          vm.$message('请选择要还款的订单');
          return;
        }
        if (
          vm.inputVal <= 0
          || vm.inputVal > vm.form.unRefundMoney
        ) {
          vm.$message('合计的还款金额不正确');
          return;
        }
        vm.getOrderCode();
      } else if (val == 3) {
        if ((vm.money * 1) >= (vm.inputVal * 1)) {
          vm.choosePayStatus = val;
        } else {
          vm.$message('您的余额不足，请选择其他支付方式');
        }
      } else {
        vm.choosePayStatus = val;
      }
    },
    // 获取用户信息
    getUserInfo() {
      const vm = this;
      const data = {
        keyWord: vm.form.phone
      };
      getMemberInfo(data).then((res) => {
        vm.memberInfo = res.data;
        vm.cardNo = res.data.cardNo;
        vm.ctName = res.data.ctName;
        vm.nickName = res.data.nickName;
        vm.userPhone = res.data.phone;
        vm.tableData = res.data.lookOnAccounts;
        vm.money = res.data.money;
      });
    },
    // 确认支付
    confirmPay() {
      const vm = this;
      if (!vm.inputVal) {
        vm.$message('请选择要还款的订单');
        return;
      }
      if (
        vm.inputVal <= 0
        || vm.inputVal > vm.form.unRefundMoney
      ) {
        vm.$message('合计的还款金额不正确');
        return;
      }
      if (!vm.choosePayStatus) {
        vm.$message('请选择支付方式');
        return;
      }
      const data = [];
      this.comfirmList.forEach((a) => {
        const obj = {};
        obj.accountid = a.id;
        obj.cardNo = a.cardno;
        obj.memberid = vm.form.memberId;
        obj.money = a.noPayMoney;
        obj.orderCode = vm.choosePayStatus == 4 ? vm.sanQPayOrder : '';
        obj.pwd = vm.choosePayStatus == 3 ? vm.payPassword : '';
        obj.refundway = vm.choosePayStatus;
        data.push(obj);
      });
      vm.disPayBtn = true;
      comfirmHk(data).then((res) => {
        if (res.code == 0) {
          this.$emit('search');
          vm.$message({
            message: '还款成功',
            type: 'success'
          });
          vm.choosePayStatus = 1;
          vm.payPassword = '';
          vm.form.dialog = false;
          vm.eqCodePayDialog = false;
          setTimeout(() => {
            vm.disPayBtn = false;
          }, 1000);
        } else {
          setTimeout(() => {
            vm.disPayBtn = false;
          }, 1000);
        }
      });
    },
    // 取消支付
    cancelPay() {
      this.form.dialog = false;
    },
    // 获取扫码支付订单号
    getOrderCode() {
      this.paymentCode = '';
      this.changePayImgStatus = true;
      this.choosePayStatus = 4;
      getOrderCode({}).then((res) => {
        if (res.code === 0) {
          this.sanQPayOrder = res.data.orderCode;
          this.eqCodePayDialog = true;
          this.getScanPayStatus();
        }
      });
    },
    // 扫码支付状态
    getScanPayStatus() {
      this.setInterFlag = setInterval(() => {
        getScanPayStatus({ orderCode: this.sanQPayOrder }).then((res) => {
          if (res.code == 0) {
            // 0:未支付，1：已支付，-1：已失效
            if (res.data.status == 1) {
              this.$message({
                message: '已支付',
                type: 'success',
                duration: 1500
              });
              clearInterval(this.setInterFlag);
              this.confirmPay();
            } else if (res.data.status == -1) {
              this.$message.error('二维码已失效，请重新获取');
              clearInterval(this.setInterFlag);
            }
          } else {
            clearInterval(this.setInterFlag);
            this.$message.error(res.msg);
          }
        });
      }, 1000);
    },
    // 清楚定时器
    clearBusinessLimit() {
      this.choosePayStatus = 1;
      clearInterval(this.setInterFlag);
    },
    // 扫码支付--提交事件
    scanQPaySubmit() {
      this.Lib.keyboardBlur();
      const data = {
        sceneType: 0, // 0：erp,1:店员端,2:pad,3:小程序粉丝端
        memberType: this.cardNo ? 1 : 0, // 0:不使用优惠，1：会员优惠，2：星球优惠)
        orderType: 3, // 0:服务开单，1：快捷收银，2：套餐购买,3: 还款
        orderCode: this.sanQPayOrder,
        barCode: this.paymentCode,
        payType: this.changePayImgStatus ? 0 : 1,
        money: this.inputVal
      };
      this.scanQPayLoading = true;
      newBarCodePay(data).then((res) => {
        if (res.code == 0) {
          this.scanQPayLoading = false;
        }
        this.scanQPayLoading = false;
        this.$nextTick(() => {
          this.$refs.refsqp.focus();
        }, 100);
      });
    }
  }
};
// eslint-disable-next-line no-unused-vars
function didGetQRCode(code) { }
</script>

<style lang="less" scoped>
.hdScanIcon {
  width: 16px;
  height: 16px;
  position: absolute;
  z-index: 1;
  margin: 10px 0 0 92px;
  padding: 12px 10px;
  cursor: pointer;
}
.repayTotal {
  padding-top: 15px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  span {
    padding-right: 5px;
  }
  samp {
    font-size: 18px;
  }
}
</style>
<style>
.input-with-select .el-input__inner {
  padding-left: 36px !important;
}
.el-checkbox__input {
  line-height: inherit;
}
</style>
